import {
  FILL_ENTITIES,
  EntityActionTypes,
  saveEntityActionType,
  deleteEntityActionType,
} from '../../model/entity/action';
import { Entity } from '../../model/intent/types';
import { createActions } from '../../helpers/actionsHelper';

export function fillEntities(entities: Entity[]): EntityActionTypes {
  return {
    type: FILL_ENTITIES,
    payload: entities,
  };
}

export const saveEntityAction = createActions<EntityActionTypes, Entity, Entity>(saveEntityActionType);

export const deleteEntityAction = createActions<EntityActionTypes, string, {}>(deleteEntityActionType);
